import { instance2 } from "./http";

const layerGetAll = async () => {
  const response = await instance2.get('/layers/getAll').then(
    response => {
      return response.data;
    }
  ).catch(error => {
    return error
  });
  return response;
}

export const layerservices = {
  layerGetAll
}